import { Select } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { useDepartments } from '../../utils/api-hooks/department.hook';
import { map } from 'lodash';

type DepartmentSelectorProps = {
  isRequired?: boolean;
  multiple?: boolean;
  disabled?: boolean;
};

export default function DepartmentSelectorContainer(
  props: DepartmentSelectorProps
) {
  const { multiple, isRequired, disabled } = props;
  const { data: { data } = {}, isLoading } = useDepartments();

  return (
    <FormItem
      name={multiple ? 'departmentIds' : 'departmentId'}
      label="部門"
      rules={[{ required: isRequired, message: '請選擇部門' }]}
    >
      <Select
        placeholder="請選擇部門"
        options={map(data, (department) => ({
          label: department.name,
          value: department.id,
        }))}
        loading={isLoading}
        disabled={disabled}
      />
    </FormItem>
  );
}
